import { createFileRoute, redirect } from "@tanstack/react-router";

import { authQueries } from "@/api/resources/auth/queries";
import VerifyCompleteSignupPage from "@/components/Verification/VerifyCompleteSignupPage";

export const Route = createFileRoute("/account/verify/complete-signup")({
  beforeLoad: async ({ context }) => {
    // redirect to password request page if claims not exists
    const claims = await context.queryClient.fetchQuery(authQueries.getAuthClaims());
    if (!claims) {
      throw redirect({
        to: "/account/password/request",
        search: {
          malformed: true,
        },
      });
    }
  },
  component: VerifyCompleteSignupPage,
});
